// Moves the homepage testimonials along every few seconds while they're on screen in a visible
// tab. It pauses while the pointer or focus is inside and stops once someone uses the arrows.
const STEP_MS = 7000;

const TestimonialRotateHooks = {
  MarketingTestimonialRotate: {
    mounted() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      this.visible = false;
      this.hovered = false;
      this.stopped = false;

      this.observer = new IntersectionObserver(
        ([entry]) => {
          this.visible = entry.isIntersecting;
          this.schedule();
        },
        { threshold: 0.5 },
      );
      this.observer.observe(this.el);

      this.pause = () => {
        this.hovered = true;
        this.schedule();
      };
      this.resume = () => {
        this.hovered = false;
        this.schedule();
      };
      this.stop = event => {
        if (!event.isTrusted || !event.target.closest('[phx-click]')) return;
        this.stopped = true;
        this.schedule();
      };
      this.onVisibilityChange = () => this.schedule();

      this.el.addEventListener('pointerenter', this.pause);
      this.el.addEventListener('pointerleave', this.resume);
      this.el.addEventListener('focusin', this.pause);
      this.el.addEventListener('focusout', this.resume);
      this.el.addEventListener('click', this.stop);
      document.addEventListener('visibilitychange', this.onVisibilityChange);
    },

    updated() {
      // Each quote gets its full time on screen.
      this.schedule();
    },

    destroyed() {
      clearTimeout(this.timer);
      this.observer?.disconnect();
      document.removeEventListener('visibilitychange', this.onVisibilityChange);
    },

    schedule() {
      clearTimeout(this.timer);
      if (!this.visible || this.hovered || this.stopped || document.hidden) return;

      this.timer = setTimeout(() => this.pushEvent('testimonial', { step: 'next' }), STEP_MS);
    },
  },
};

export default TestimonialRotateHooks;
